import { observable, action, reaction, makeObservable } from 'mobx';
import axios from 'axios';

class treeStore {
  opened_sections={};
  loaded_tree={};
  have_children={};
  show_more={};
  loaded={};
  category=0;
  title='';
  selected_section=0;

  par=null;
  constructor(par) {
    makeObservable(this, {
      opened_sections:observable,
      loaded_tree:observable,
      have_children:observable,
      category:observable,
      selected_section:observable,
      show_more:observable,
      loaded:observable,
    })
    this.par=par;
    reaction(()=>{
      return this.selected_section;
    },(sectionId)=>{
      this.par.communicatorStore.pushMessage({
        type:'output',
        command:'section_selected',
        section_id: sectionId
      })
    })
  }
  setCategory(cat) {
    this.category=cat;
  }
  closeSection(id) {
    if(this.opened_sections[id]) {
      this.opened_sections[id] = false;
    }
  }
  openSection(id) {
    if(!this.opened_sections[id]) {
      this.opened_sections[id]=true;
    }
  }
  selectSection(id) {
    this.selected_section=id;
  }
  toggleSection(id)
  {
    if(this.opened_sections[id]) {
      this.opened_sections[id]=false;
    } else {
      this.opened_sections[id]=true;
    }
  }
  refreshAll() {
    for(let section in this.loaded_tree) {
      this.loaded_tree[section].fetching=true;

      const limit=Math.ceil(this.loaded_tree[section].data.items.length/50)*50;
      // axios.get(`/sysapi/dynamic/${this.category}/sections/tree`, { params:{ section:section, offset:0, limit:limit } } ).then((data) => {
      axios.get(`${this.par.routes.tree}`, { params:{ section:section, offset:0, limit:limit } } ).then((data) => {

        if (data.data.answer.have_children) {
          for (let i in data.data.answer.have_children) {
            this.have_children[data.data.answer.have_children[i]] = 1;
          }
        }
        if (data.data.answer.no_children) {
          for (let i in data.data.answer.no_children) {
            if (this.have_children[data.data.answer.no_children[i]]) {
              delete this.have_children[data.data.answer.no_children[i]];
            }
          }
        }
        this.show_more[section] = data.data.answer.show_more;
        this.loaded[section] = data.data.answer.items ? data.data.answer.items.length : 0;
        this.loaded_tree[section].data = data.data.answer;
        this.loaded_tree[section].fetching = false;

      });
    }
  }
  loadTreeData(section,more)
  {
    if(!this.loaded_tree[section]) {
      this.loaded_tree[section] = { fetching: true, data:null };
    } else {
      this.loaded_tree[section].fetching=true;
    }
    let offset=0;
    if(more) {
      offset=this.loaded[section];
    }

    const params={ section, offset }

    if(this.loaded[section]) {
      params.limit=Math.ceil(this.loaded[section]/50)*50;
    }

    // return axios.get(`/sysapi/dynamic/${this.category}/sections/tree`, { params } ).then((data) => {
    return axios.get(`${this.par.routes.tree}`, { params } ).then((data) => {
      if (data.data.answer.have_children) {
        for (let i in data.data.answer.have_children) {
          this.have_children[data.data.answer.have_children[i]] = 1;
        }
      }
      if (data.data.answer.no_children) {
        for (let i in data.data.answer.no_children) {
          if(this.have_children[data.data.answer.no_children[i]]) {
            delete this.have_children[data.data.answer.no_children[i]];
          }
        }
      }
      this.show_more[section]=data.data.answer.show_more;
      if(more) {
        this.loaded[section]+=data.data.answer.items?data.data.answer.items.length:0;
      } else {
        this.loaded[section]=data.data.answer.items?data.data.answer.items.length:0;
      }

      if(more) {
        this.loaded_tree[section].data.items.push(...data.data.answer.items);
      } else {
        this.loaded_tree[section].data = data.data.answer;
      }
      this.loaded_tree[section].fetching = false;
      console.log("first then!");
    }).then(()=>{ console.log("second then!"); });
  }
  loadTree(sectionId,more=false) {
    const params={};
    params.section=sectionId;
    if(!this.loaded_tree[sectionId] || more) {
      return this.loadTreeData(sectionId,more);
    }
  }
}

/*
decorate(treeStore,{
  opened_sections:observable,
  loaded_tree:observable,
  have_children:observable,
  category:observable,
  selected_section:observable,
  show_more:observable,
  loaded:observable,
});
*/

export default treeStore;
